// import haversine from 'haversine';

/**
 * Get coordinates (latitude, longitude) from a ZIP code using OpenCage API
 * @param {string} zipcode - The ZIP code to lookup
 * @returns {Promise<{latitude: number, longitude: number}>} Coordinates object
 */
export const getCoordinatesFromZipcode = async (zipcode) => {
  const apiKey = process.env.REACT_APP_OPENCAGE_API_KEY;

  if (!apiKey) {
    throw new Error('OpenCage API key is not configured. Please add REACT_APP_OPENCAGE_API_KEY to your .env file.');
  }

  try {
    const response = await fetch(
      `https://api.opencagedata.com/geocode/v1/json?q=${zipcode}&key=${apiKey}&limit=1`
    );

    if (!response.ok) {
      throw new Error(`API request failed with status ${response.status}`);
    }

    const data = await response.json();

    if (!data.results || data.results.length === 0) {
      throw new Error(`No results found for ZIP code: ${zipcode}`);
    }

    const { lat, lng } = data.results[0].geometry;
    return { latitude: lat, longitude: lng };
  } catch (error) {
    console.error('Error fetching coordinates:', error);
    throw error;
  }
};

/**
 * Filter distributors by radius from a given point
 * @param {number} centerLat - Center latitude
 * @param {number} centerLng - Center longitude
 * @param {Array} distributors - Array of distributor objects with latitude and longitude
 * @param {number} radiusInMiles - Radius in miles
 * @returns {Array} Filtered distributors with distance property added
 */
/* export const filterDistributorsByRadius = (
  centerLat,
  centerLng,
  distributors,
  radiusInMiles = 100
) => {
  const centerPoint = { latitude: centerLat, longitude: centerLng };

  const filtered = distributors.filter((distributor) => {
    if (!distributor.latitude || !distributor.longitude) {
      return false; // Skip distributors without coordinates
    }

    const distributorPoint = {
      latitude: distributor.latitude,
      longitude: distributor.longitude,
    };

    const distanceInMiles = haversine(centerPoint, distributorPoint, {
      unit: 'mi',
    });

    return distanceInMiles <= radiusInMiles;
  });

  // Add distance to each distributor for display
  const withDistance = filtered.map((distributor) => {
    const distributorPoint = {
      latitude: distributor.latitude,
      longitude: distributor.longitude,
    };
    const distanceInMiles = haversine(centerPoint, distributorPoint, {
      unit: 'mi',
    });
    return {
      ...distributor,
      distance: parseFloat(distanceInMiles.toFixed(1)),
    };
  });

  // Sort by distance
  return withDistance.sort((a, b) => a.distance - b.distance);
}; */


export const filterDistributorsByRadius = (
  centerLat,
  centerLng,
  distributors,
  radiusInMiles = 100
) => {

  const filtered = distributors.filter((distributor) => {

    if (
      distributor.latitude === undefined ||
      distributor.longitude === undefined
    ) {
      return false;
    }

    const distanceInMiles = calculateDistance(
      Number(centerLat),
      Number(centerLng),
      Number(distributor.latitude),
      Number(distributor.longitude)
    );

    return distanceInMiles <= radiusInMiles;
  });

  const withDistance = filtered.map((distributor) => {

    const distanceInMiles = calculateDistance(
      Number(centerLat),
      Number(centerLng),
      Number(distributor.latitude),
      Number(distributor.longitude)
    );

    return {
      ...distributor,
      distance: parseFloat(distanceInMiles.toFixed(1)),
    };
  });

  return withDistance.sort(
    (a, b) => a.distance - b.distance
  );
};



const toRadians = (degrees) => {
  return degrees * (Math.PI / 180);
};

export const calculateDistance = (
  lat1,
  lon1,
  lat2,
  lon2
) => {

  const earthRadius = 3958.8; // miles

  const dLat = toRadians(lat2 - lat1);
  const dLon = toRadians(lon2 - lon1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRadians(lat1)) *
    Math.cos(toRadians(lat2)) *
    Math.sin(dLon / 2) *
    Math.sin(dLon / 2);

  const c = 2 * Math.atan2(
    Math.sqrt(a),
    Math.sqrt(1 - a)
  );

  return earthRadius * c;
};
